import { render, staticRenderFns } from "./ShoppingProdukte.vue?vue&type=template&id=90d8b40c"
import script from "./ShoppingProdukte.vue?vue&type=script&lang=ts"
export * from "./ShoppingProdukte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports